import { Box, Stack } from '../../../shared/layouts';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Modal from '../../../shared/Modal';
import DataSourcesList from './DataSourcesList';
import Button from '../../../shared/Button';

const UnavailableDataSourcesModal = ({
  showUnvailableDataSourcesModal,
  setShowUnavailableDataSourcesModal,
  unavailableDataSources
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Modal
      isOpen={showUnvailableDataSourcesModal}
      onRequestClose={() => setShowUnavailableDataSourcesModal(false)}
      showProgressBar
      progressBarColor="alert"
    >
      <Stack space="m">
        <Box fontScale="xl" fontWeight="bold">
          {t('Niet alle databronnen zijn beschikbaar')}
        </Box>
        <p>
          {t(
            'Je gaat gegevens ophalen bij verschillende bronnen. Helaas zijn op dit moment niet alle bronnen beschikbaar.'
          )}
        </p>
        <strong>
          {t('Onderstaande bronnen kunnen hierdoor niet geraadpleegd worden:')}
        </strong>
        <DataSourcesList sources={unavailableDataSources} />
        <Stack
          direction={'row'}
          space={'s'}
          alignItems={'center'}
          float={'right'}
        >
          <Button
            style={{ marginLeft: 'auto' }}
            buttonSize={'small'}
            variant={'alert-outline'}
            onClick={() => setShowUnavailableDataSourcesModal(false)}
          >
            {t('Toch verder gaan')}
          </Button>
          <Button
            buttonSize={'small'}
            variant={'alert'}
            onClick={() => navigate('/requests')}
          >
            {t('Terug')}
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default UnavailableDataSourcesModal;
